import { Body2, Body4, Bold, H6, Underline } from '@ui';

export const TermsOfService = () => {
  const isOpCo = true;
  return (
    <div>
      <Body2>
        <Bold>{!isOpCo ? 'NVSTR TECHNOLOGIES LLC' : 'NVSTR FINANCIAL LLC DBA TORNADO'}</Bold>
      </Body2>
      <Body2>
        <Bold>WEB SITE & APP TERMS OF SERVICE</Bold>
      </Body2>
      <Body2>
        <Bold>IMPORTANT - PLEASE READ CAREFULLY</Bold>
      </Body2>
      <Body4>
        {`Here is a summary of the key provisions of this Web Site Terms of
          Service (this 'Terms of Service' or these 'Terms').`}
      </Body4>
      <Body4>
        <Underline>Confidentiality:</Underline> All materials and content on this site are considered confidential and
        you may not publish or disclose such materials or content without Tornado&apos;s written permission. Violations
        of the confidentiality provisions in this Terms of Service may result in the termination of your access to the
        site
        {isOpCo ? 'and liquidation of your investments made through the Services' : ''}
      </Body4>
      <Body4>
        <Underline>Tell the Truth:</Underline> Any material that you post to the site and any representations you make
        must be truthful and must not harm, offend or violate the rights of others.
      </Body4>
      <Body4>
        <Underline>Ownership:</Underline> Tornado owns all content and material on the site, including any material or
        investment strategies posted to the site by you.
      </Body4>
      <Body4>
        <Underline>No Recommendation or Guarantee:</Underline> All materials and content are presented on the site
        without guarantee of completeness or accuracy and are not a recommendation to make any investment decision.
      </Body4>
      <Body4>
        <Bold>
          It is important, however, that you read these Terms in their entirety as you are bound by and must follow them
          in their entirety.
        </Bold>
      </Body4>
      <H6>
        <Bold>1. INTRODUCTION</Bold>
      </H6>
      <Body4>
        <Bold>Please read these Terms carefully.</Bold> By clicking “I Agree” or simply by using one or more of the
        Services (as defined below), Subscriber (as defined below) agrees that these Terms, our Privacy Policy, and any
        other policies instituted by Tornado from time to time, and any agreements between Tornado and Subscriber
        entered into from time to time{' '}
        {isOpCo
          ? `(including, but not limited to, an Account Agreement, User Agreement or Margin Agreement)
          govern any and all access to or use of the Services made at any time by Subscriber.  Whether Subscriber is paying for the services or not, and whether Subscriber has a free trial or not, Subscriber’s use of the Services is conditioned on compliance with these Terms.`
          : ''}
      </Body4>
      <Body4>
        If you do not agree to these Terms, you may not access or use the Services and you must cease any access or use
        immediately. If you have any questions regarding these Terms, please contact us at legal@tornado.com.
      </Body4>
      <Body4>
        <Bold>
          The Services and the Content do not constitute and should not be construed as a recommendation or endorsement
          of any investment strategy or as an offering of advisory services or an offer to sell or solicitation to buy
          any securities or related financial instruments in any jurisdiction.
        </Bold>
      </Body4>
      <H6>
        <Bold>2. DEFINITIONS</Bold>
      </H6>
      <Body4>For purposes of these Terms, the following words shall have the meanings ascribed to them:</Body4>
      <Body4>
        <Bold>{`"Content"`}</Bold> means all material, data, information and products on, accessible through, or
        generated from the Services or provided as part of any Service (including, without limitation, any publications
        or messages sent as part of a Service), and any documentation related thereto.
      </Body4>
      <Body4>
        <Bold>{`"Privacy Policy"`}</Bold> means Tornado&apos;s privacy policy for the Services and the Content as in
        effect from time to time.
      </Body4>
      <Body4>
        <Bold>{`"Tornado", "we", "us", "our"`}</Bold> means Nvstr {isOpCo ? 'Financial' : 'Technologies'} LLC dba
        Tornado and any of its past, present or future affiliates or successors.
      </Body4>
      <Body4>
        <Bold>{`"Services"`}</Bold> means (a) any online, electronic or hard-copy Content, (b) any website, (c) any
        messaging, chat or other communication service or capability, including without limitation notification emails,
        (d) any question-and-answer schematics or click-throughs, (e) any blog site(s), posting site(s), discussion
        board(s) or similar service, and (f) any software or interface, all to the extent provided or made available by
        Tornado or any third-party provider through Tornado.
      </Body4>
      <Body4>
        <Bold>{`"Subscriber", "you", "your"`}</Bold> means (as appropriate) the person using or accessing any of the
        Services or the Content, whether themselves or through another person and whether authorized or not. In
        particular, and as the context may require, the words can mean (i) the end user, (ii) the legal entity for which
        the end user is accessing or using the Services, or (iii) both, in each case as will provide the maximum rights
        and protections to Tornado and the maximum obligations and requirements on Subscriber. To the extent an end user
        Subscriber accesses or uses the Services as an employee, partner, director, agent or representative of any legal
        entity Subscriber, the end user Subscriber warrants that s/he has the authority to agree to these Terms on
        behalf of the legal entity Subscriber. Whether you pay for the Services or not, access and/or usage is enough to
        make you a Subscriber and bind you to these Terms.
      </Body4>
      <H6>
        <Bold>{`3. USE OF THE SERVICES, CONTENT AND TRADEMARKS`}</Bold>
      </H6>
      <Body4>
        3.1 As between Tornado and Subscriber, all right, title and interest in and to the Content and the Services,
        including any and all intellectual property rights related thereto, are and will remain the exclusive property
        of Tornado. All other rights with respect to the Content and the Services, whether now existing or that may
        hereafter come into existence, that are not expressly granted to Subscriber herein are reserved for Tornado.
        Subscriber agrees to comply with all United States copyright, trademark, trade secret, patent and other
        intellectual property laws applicable thereto. Subscriber will not remove, obscure or alter any copyright
        notices, trademark notices or other proprietary rights notices affixed to or contained within the Content or the
        Services. The trademarks belonging to Tornado may not be used in connection with any product or service that
        does not originate with Tornado, in any manner that is likely to cause confusion among users, or in any manner
        that disparages or discredits Tornado. All other trademarks appearing on this site are the property of their
        respective owners.
      </Body4>
      <Body4>
        3.2 Subscriber acknowledges and agrees that the Content and the Services are the valuable confidential property
        of Tornado. Subscriber may use the Services and the Content solely for its own use and benefit and not for
        resale or other transfer or disposition to any other person.&nbsp; Subscriber agrees to take or cause to be
        taken all necessary precautions to maintain the confidentiality and proprietary nature of the Content and the
        Services. Subscriber is prohibited from using, reproducing, modifying, transferring, exploiting, distributing or
        disposing of any of the Services or the Content for any purpose, or in any manner that might compete with
        Tornado. Any request for permission to republish, reprint or use for any other purpose any Content or trademarks
        should be sent to legal@tornado.com.
      </Body4>
      <Body4>
        If, in Tornado&apos;s opinion, Subscriber has failed to comply with this Section 3.2, Tornado will have the{' '}
        {isOpCo ? '  (i)\n' + '    right to terminate any or all of the Services to Subscriber' : ''}{' '}
        {isOpCo
          ? "and (ii) to the extent permitted by law, liquidate any investments Subscriber has made through the Services at prices in Tornado's sole discretion, and distribute such proceeds to Subscriber\n"
          : ''}{' '}
        thus terminating the relationship between Tornado and Subscriber. For the avoidance of doubt, in the event of
        such termination, the obligations of this Section 3.2 will remain in effect into perpetuity.
      </Body4>
      <Body4>
        3.3 Subscriber will be given one or more user names and passwords, as appropriate for its registration or
        subscription to the relevant Service(s). Tornado has the right to disable any user name, password or other
        identifier, and to terminate any or all of the Services to Subscriber, at any time in our sole discretion,
        including if, in Tornado&apos;s opinion, Subscriber has violated any provision of these Terms. Subscriber agrees
        not to create another account, user name or password after such termination without Tornado&apos;s permission.
        Tornado reserves the right to access and monitor password-protected information, including any information that
        Subscriber may upload or input and any information concerning Subscriber’s activities in relation to any
        Services or Content for any purposes, so long as they are in compliance with Tornado&apos;s Privacy
        Policy.&nbsp;&nbsp;Tornado may also use cookies and similar technical tools as set out in the Privacy Policy to
        collect information and display advertisements that may be of interest to Subscriber and for such other purposes
        as are set out in the Privacy Policy.
      </Body4>
      <H6>
        <Bold>4. SUBSCRIBER’S OBLIGATIONS</Bold>
      </H6>
      <Body4>
        4.1 You represent and warrant that: (a) you have the capacity to agree to these Terms; and (b) you are at least
        eighteen (18) years of age, unless your parent or guardian has agreed to these terms on your behalf.
        {isOpCo
          ? ` In the event that you are under 18, you must not access certain areas of the site and/or attempt to open an account to trade actual securities. `
          : ' '}
        If you are under 18, you must have your parent or guardian’s permission to enter and use
        {isOpCo ? ' the portions of ' : ' '}
        the site
        {isOpCo ? ' that are available to persons under 18 ' : ' '}
        and your parent or guardian must agree to these Terms and hold you accountable for their violation.
      </Body4>
      <Body4>4.2 Subscriber covenants and agrees that it will:</Body4>
      <Body4>
        (a) comply fully with these Terms, including without limitation the confidentiality terms in Section 3.2, and
        with all applicable laws, rules and regulations in relation to the Services, including without limitation laws
        relating to the use of intellectual property, insider information, insider trading, and market manipulation;
      </Body4>
      <Body4>
        (b) not use the Services or the Content outside the scope of the permitted use under these Terms and not
        infringe any intellectual property or other rights in or relating to the Services, the Content or of any third
        party;
      </Body4>
      <Body4>
        (c) not copy, reproduce, screen capture, recompile, decompile, disassemble, reverse engineer, upload, download,
        transmit, create derivative works from or otherwise exploit or tamper with the Services or the Content, except
        as follows:
      </Body4>
      <Body4>
        <ul>
          <li>
            (i) Your computer may temporarily store copies of such materials in RAM incidental to your accessing and
            viewing those materials.
          </li>
          <li>
            (ii) You may store files that are automatically cached by your Web browser for display enhancement purposes.
          </li>
          <li>
            (iii) If we provide desktop, mobile or other applications for download, you may download a single copy to
            your computer or mobile device solely for your own use as disclosed to Tornado at the time of downloading,
            provided you agree to be bound by our end-user license agreement for such applications.
          </li>
        </ul>
      </Body4>
      <Body4>
        (d) not prevent or restrict (or attempt to prevent or restrict) the use of the Services or the Content by any
        other authorized user nor hack into or cause damage to any server or other equipment operated by Tornado or on
        its behalf;
      </Body4>
      <Body4>(e) provide accurate and complete information at all times, and keep updated all such information;</Body4>
      <Body4>
        (f) treat all user name and password information as confidential, and not disclose it to any other person;
        immediately notify Tornado of any unauthorized access to or use of Subscriber’s user name or password or any
        other breach of security; use particular caution when accessing the Services from a public or shared computer so
        that others are not able to view or record Subscriber’s user name, password or other personal information;
      </Body4>
      <Body4>
        (g) access only those accounts on which you are authorized to act, and you agree to use your own user names,
        logins, passwords, and security questions and answers when accessing accounts on which you are authorized to
        act. You agree not to obtain or attempt to obtain unauthorized access to such parts of or features of the
        Content and Services through any means not intentionally made available to you by Tornado; and
      </Body4>
      <Body4>
        (h) be responsible for procuring the necessary equipment and paying any and all charges or fees necessary to
        access and/or use the Services.
      </Body4>
      <Body4>4.3 Additionally, Subscriber agrees not to:</Body4>
      <Body4>
        (a) use the Services in any manner that could disable, overburden, damage, or impair the site or any Services or
        interfere with any other party&apos;s use of the Services, including their ability to engage in real time
        activities through the Services;
      </Body4>
      <Body4>
        (b) use any robot, spider or other automatic device, process or means to access the Services for any purpose,
        including monitoring or copying any of the Content;
      </Body4>
      <Body4>
        (c) redeliver any page, text, image, Content or Services on this site using “framing” or other technology;
      </Body4>
      <Body4>
        (d) use any device, software or routine, or engage in any activity, that interferes with the proper working of
        the Services (including without limitation any denial-of-service attack or distributed denial-of-service
        attack), or introduce any viruses, “Trojan horses,” worms, logic bombs or other material which is malicious or
        technologically harmful;
      </Body4>
      <Body4>
        (e) attempt to gain or to provide to another unauthorized access to, interfere with, damage or disrupt any parts
        of the Services, or any server, network, account, computer or database connected to or utilized by the Services;
      </Body4>
      <Body4>
        (f) use the Services to promote, offer for sale or sell any product or service, including, without limitation,
        any financial or investment product, security or service;
      </Body4>
      <Body4>
        (g) intentionally or unintentionally engage in activity that: (i) violates any law or regulation; or (ii)
        violates contractual or fiduciary obligations, including, without limitation, breach of contract and
        non-disclosure agreements;
      </Body4>
      <Body4>
        (h) bully, intimidate, or harass any member or create Posted Materials that are threatening, hateful, harmful,
        abusive, tortious, defamatory, false, libelous, vulgar, obscene, invasive of another&apos;s privacy, racially or
        ethnically objectionable, pornographic, incites violence, or contains nudity or graphic or gratuitous violence;
        or
      </Body4>
      <Body4>
        {`(i)  create Posted Materials or Content that violate a third party's proprietary rights, including, without limitation, patents, trade secrets, copyrights, rights, privacy or publicity, or materials that reveal personal, private or sensitive information about another person, without that person's consent, or otherwise infringe any third party's copyright, patent, trademark, trade secret, or other proprietary rights or rights of publicity or privacy.`}
      </Body4>
      <H6>
        <Bold>5. INTERACTIVE SERVICES</Bold>
      </H6>
      <Body4>
        5.1 The Services may include (a) blog site(s), posting site(s), discussion board(s), dashboard(s) or similar
        services, (b) messaging, chat or other communications methods, and (c) other public areas that allow
        interactivity between users and/or feedback to be provided to us (together <Bold>{`"Interactive Areas"`}</Bold>{' '}
        ). We do not control and are not responsible for the information and/or materials posted to Interactive Areas by
        you or any third party including without limitation data, content, text, photographs, graphics, images, videos,
        messages, comments, quotations, files, documents and any other materials that you submit, upload, post, e-mail,
        transmit or otherwise make available via the site (<Bold>{`"Posted Material"`}</Bold> ) and as a result, cannot
        guarantee the veracity or accuracy of any Posted Material. All use of the Interactive Areas is at your risk and
        you should not rely on Posted Material in any way.
      </Body4>
      <Body4>
        5.2 By submitting, uploading, posting, e-mailing or transmitting Posted Material to the site, you represent and
        warrant that either you own all right, title and interest in and to the Posted Material or have express
        permission from the owner to copy and use such Posted Material for all purposes related to the site.
      </Body4>
      <Body4>
        5.3 You hereby grant us a non-exclusive, perpetual, sub-licensable, transferable, royalty-free license to use,
        store, translate, publish, display, broadcast, perform, disclose, distribute, sell, create derivative works
        from, reproduce, modify and/or sublicense all of your Posted Material, and consent to the use and viewing of
        same by every other person utilizing the Services.
      </Body4>
      <Body4>
        5.4 You are responsible for the content of your Posted Material and you may not within the Interactive Areas or
        otherwise in relation to any Service post, publish, link to, upload, download, send, distribute, use or re-use
        any information or material:
      </Body4>
      <Body4>
        (a) that is or could be taken to be the provision of unauthorized advice (including, without limitation, legal,
        accounting, tax or investment advice) or which has the purpose of affecting improperly the price or value of any
        asset;
      </Body4>
      <Body4>
        (b) obtained in breach of confidence or that contains confidential information or infringes any intellectual
        property rights or rights of privacy or other rights of any third party;
      </Body4>
      <Body4>
        (c) that is offensive, harmful, threatening, abusive, indecent, defamatory, obscene, pornographic, invasive of
        another&apos;s privacy or publicity rights, degrading or menacing, or is otherwise contrary to applicable law or
        regulation or promoting an illegal act;
      </Body4>
      <Body4>
        (d) that personally attacks or is derogatory toward Tornado as an entity, Tornado employees or any Tornado
        products or services;
      </Body4>
      <Body4>
        (e) that harms minors in any way, including, but not limited to, submitting, uploading, posting, e-mailing,
        transmitting, or otherwise making available content that violates child pornography laws, child sexual
        exploitation laws, or laws prohibiting the depiction of minors engaged in sexual conduct; or
      </Body4>
      <Body4>
        (f) that constitutes unsolicited advertising or promotional material, including but not limited to any chain
        emails, unsolicited commercial emails, unsolicited bulk email, “spam” or mail bombs.
      </Body4>
      <Body4>5.5 Without prejudice to section 5.4 above, you may not:</Body4>
      <Body4>(a) use any Interactive Area to carry out criminal, fraudulent or illegal activities;</Body4>
      <Body4>
        (b) use any Interactive Area to impersonate any person, company, group or entity or misrepresent a relationship
        to or with any of the same;
      </Body4>
      <Body4>(c) disguise the origin of any message posted in any Interactive Area;</Body4>
      <Body4>
        (d) collect, store, disclose or otherwise process any personal data in relation to your use of any Interactive
        Area without the&nbsp;knowledge of the relevant individual or in breach of applicable data protection laws;
      </Body4>
      <Body4>
        (e) forge headers or otherwise manipulate identifiers in order to disguise the origin of any Posted Material
        transmitted through the site;
      </Body4>
      <Body4>
        (f) submit, upload, post, e-mail, transmit or otherwise make available any material that contains viruses or any
        other computer code, files or programs designed to interrupt, destroy, or limit the functionality of any
        computer software or hardware or telecommunications equipment; nor
      </Body4>
      <Body4>
        (g) intentionally or unintentionally violate any applicable local, state, national, or international laws,
        rules, regulations, decrees, acts, orders, directives, legislation, bills or statutes.
      </Body4>
      <Body4>
        5.5 You must comply with any additional rules which may, from time to time, be issued by us at particular
        sections of the Interactive Areas and such rules shall be deemed incorporated into these Terms.
      </Body4>
      <Body4>
        5.6 By accessing the Interactive Areas, you agree to indemnify and hold us harmless against all claims, damages,
        costs and expenses (including legal and other professional fees) which we may incur as a result of any of your
        Posted Material.
      </Body4>
      <Body4>
        5.7 We reserve the right to remove Posted Material at any time, for any or no reason, and without notice,
        including without limitation for any failure to comply with the provisions of this Section.&nbsp; If any Posted
        Material fails to comply with the provisions of this Section, we reserve the right to prevent you from accessing
        the Interactive Areas.
      </Body4>
      <Body4>
        5.8 Our employees or representatives may also submit Posted Material to the Interactive Areas. In doing so, such
        employees or representatives shall act in a personal capacity and any views they might express shall not be
        considered our views nor the views of a legal, accounting, tax, financial or other professional advisor.
      </Body4>
      <Body4>5.9 Notice for Claims of Copyright Violations</Body4>
      <Body4>
        If you believe that your work has been copied and posted in the U.S. on any Interactive Area or otherwise within
        the Services in a way that constitutes copyright infringement under U.S. copyright law, you should notify us
        promptly at legal@tornado.com with a written notice that sets forth the infringement details. To be effective,
        the notice must contain the following information:
      </Body4>
      <Body4>(a) a description of the copyrighted work that you believe has been infringed;</Body4>
      <Body4>
        (b) a description of the material that you claim is infringing the copyrighted work and a detailed description
        of where it is located;
      </Body4>
      <Body4>(c) your address, telephone number, and email address;</Body4>
      <Body4>
        (d) a written statement by you that you have a good faith belief that the disputed use is not authorized by the
        copyright owner, its agent, or the law;
      </Body4>
      <Body4>
        (e) a statement by you, made under penalty of perjury, that the above information in your notice is accurate and
        that you are the copyright owner or authorized to act on the copyright owner&apos;s behalf; and
      </Body4>
      <Body4>
        (f) an electronic or physical signature of the person authorized to act on behalf of the owner of the copyright
        interest.
      </Body4>
      <H6>
        <Bold>6. ADVERTISEMENTS, LINKS AND THIRD PARTY TRANSACTIONS</Bold>
      </H6>
      <Body4>6.1 The Services may contain:</Body4>
      <Body4>
        (a) links to other websites provided by third parties (<Bold>{`"External Sites"`}</Bold>
        ). We shall endeavor to highlight such links although some External Sites may be co-branded with ours.&nbsp;
        External Sites may advertise or provide the opportunity for you to purchase third party products or services (
        <Bold>{`"Third Party Services"`}</Bold>); and/or
      </Body4>
      <Body4>
        (b) advertisements for, and/or the opportunity for you to purchase products or services from Third Party
        Services or Tornado.
      </Body4>
      <Body4>
        6.2 The content of External Sites and Third Party Services is not maintained or controlled by us and we are
        therefore not responsible for the availability, content or accuracy of External Sites or Third Party
        Services.&nbsp; We do not (a) make any warranty, express or implied, with respect to the use of the links
        provided; (b) guarantee the accuracy, completeness, usefulness or adequacy of External Sites or Third Party
        Services; or (c) make any endorsement, express or implied, of any External Sites or Third Party Services. Any
        advertisement or promotion of a Third Party Service is not an inducement by us for you to enter into any
        agreement with the relevant third party.
      </Body4>
      <Body4>
        6.3 Any communications or contracts relating to Third Party Services,&nbsp;payment for and delivery of Third
        Party Services, and any other associated terms, conditions, warranties or representations are exclusively
        between you and the relevant third parties.&nbsp; You agree not to hold us liable for any loss or
        damage&nbsp;incurred as the result of any such contracts, communications or other dealings or the presence of
        such third parties on any site.
      </Body4>
      <H6>
        <Bold>7. SOFTWARE</Bold>
      </H6>
      <Body4>
        Intellectual property in any software that is made available for download through the Services (
        <Bold>{`"Software"`}</Bold>) belongs to us or our suppliers. Your use of the Software is governed by the terms
        of any license agreement or other terms of service, as applicable, that may accompany or be included with the
        Software. Do not install or use any Software unless you agree to such license agreement or terms of service, as
        applicable.
      </Body4>
      <a name={'section8'}></a>
      <H6>
        <Bold>8. INVESTMENT ANALYSIS TOOL</Bold>
      </H6>
      <Body4>
        The Optimize function (the “Optimizer”) available on this site is an Investment Analysis Tool as described in
        FINRA Rule 2214. The disclosure in this section are made in accordance with this Rule.
      </Body4>
      <Body4>
        8.1 The Optimizer is broadly based upon the mean-variance optimization method of portfolio construction as first
        developed by Harry Markowitz in 1952. Dr. Markowitz won a Nobel Prize in Economics for this work. In this
        mathematical model, the weights of individual assets within a portfolio are determined based upon return targets
        for each asset, as well as assumptions about the riskiness and correlations of the assets. The portfolio
        allocation is made such that expected returns are maximized for a given acceptable level of risk.
      </Body4>
      <Body4>
        The Optimizer uses expected returns for stock investments based on price and dividend targets that users have
        entered or affirmed. These targets can be set by the user or added from other sources, such as friends or
        well-known experts. The measure of risk for each stock is its expected standard deviation of returns, which the
        Optimizer models as standard deviation of returns over a recent trailing period. Information on how expected
        stock returns are related to each other comes from the covariance matrix, which is a mathematical object
        containing information on how stock prices have moved relative to each other over a recent trailing period.
      </Body4>
      <Body4>
        The user also enters or affirms a conviction level, which indicates how confident the user is that the stock
        will reach its price target within the specified time horizon.
      </Body4>
      <Body4>
        As with individual stocks, risk at the portfolio level is measured in standard deviation of returns.
      </Body4>
      <Body4>
        The user’s price targets, expected dividends and time horizons are the only inputs the Optimizer uses to
        calculate expected returns. If a time horizon other than annual (12 months) is specified, the Optimizer
        annualizes the projected return via a standard financial industry calculation, such that all returns can be
        evaluated by the algorithm on a normalized basis. The Optimizer does not validate quantities used for price
        targets, expected dividends, or time horizons, and no warranty is given as to their accuracy or appropriateness
        for this purpose. Historical data is used to calculate standard deviations and covariances; there is no
        guarantee that past stock market behavior will predict future results in a meaningful or useful way.
      </Body4>
      <Body4>
        The Optimizer's model approximates the distribution of stock returns as a normal distribution, which may not be
        accurate and may be especially inaccurate during periods of market turmoil or financial crises. No consideration
        is given to taxation, which may significantly impact the user's take-home profits or losses.
      </Body4>
      <Body4>
        Past returns do not guarantee future results. Investing in stocks is risky; no investment tool can completely
        eliminate risks, or reliably predict them.
      </Body4>
      <Body4>
        8.2 Results of the Optimizer may vary with each use and over time, even if all user-entered or -affirmed
        information remains the same. Examples of factors that may cause the results to vary include: levels of market
        prices, recent moves in market prices, and how asset prices have recently moved in relation to each other.
      </Body4>
      <Body4>
        8.3 Only those stocks selected by the user will be made available to the Optimizer's algorithm for inclusion in
        the analysis. The universe of possible investments from which the user may choose is common stocks, depository
        receipts, and exchange-traded funds listed on the New York Stock Exchange, Nasdaq, NYSE MKT (formerly known as
        the American Stock Exchange), and Arca. The Optimizer does not select or exclude any potential investments that
        meet the above criteria. Stocks not selected by the user for inclusion in the portfolio, and assets other than
        US-listed stocks, depository receipts, and exchange-traded funds, may have characteristics similar or superior
        to those that are included in the analysis.
      </Body4>
      <Body4>
        8.4 IMPORTANT: The projections or other information generated by the Optimizer function regarding the likelihood
        of various investment outcomes are hypothetical in nature, do not reflect actual investment results and are not
        guarantees of future results. Information outputted from the Optimizer is not, and is not to be construed as, a
        recommendation.
      </Body4>
      <a name={'section9'}></a>
      <H6>
        <Bold>9. THOUGHT LEADERS</Bold>
      </H6>
      <Body4>
        Thought&nbsp;Leader ideas are sourced from publicly available information including regulatory filings, which
        may indicate&nbsp;that&nbsp;a firm held a position in a security on a given date.&nbsp; These positions may have
        been exited or otherwise modified since that date, or they may be&nbsp;only one&nbsp;part of a more
        complex&nbsp;investment or hedging&nbsp;strategy. Thought Leader ideas are for informational purposes
        only.&nbsp; They are not investment recommendations and are not to be construed as such, and are not
        initiated,&nbsp;approved,&nbsp;or promoted by the corresponding firms or individuals. &nbsp;Unlike
        user-initiated ideas, Thought Leader ideas are comprised only of a security and a direction (buy or sell) which
        is based on the direction of the reported position of the corresponding firm on the indicated date. Any price
        targets that may be displayed in conjunction with Thought Leader ideas are sourced from the professional analyst
        community and do not reflect the specific price target of the corresponding Thought Leader.
      </Body4>
      <H6>
        <Bold>10. COMMUNITY THOUGHT LEADERS AND VIEWPOINT CONTRIBUTORS</Bold>
      </H6>
      <Body4>
        Community Thought Leaders are distinguished Tornado community members who are compensated for their
        contributions. Viewpoint Contributors are financial content creators who have chosen to share their insights
        with the Tornado community and may be compensated for their activity on the Tornado platform. They are not
        employees of Tornado and their views do not necessarily represent those of Tornado, its affiliates, or
        management. Community Thought Leader and Viewpoint Contributor content is for informational purposes to prompt
        an online discussion only and is not a recommendation, investment advice, or a research product. Tornado may
        edit or remove Community Thought Leader and Viewpoint Contributor content at any time, and may modify or revoke
        a member&apos;s Community Thought Leader or Viewpoint Contributor status. Community Thought Leaders and
        Viewpoint Contributors may or may not have a long or short position in any given security they post about.
      </Body4>
      <H6>
        <Bold>11. SUBSCRIPTION SERVICE</Bold>
      </H6>
      <Body4>
        11.1 You may be enrolled in a paid subscription service (&ldquo;Subscription Service&ldquo;), in which case, you
        agree to the following terms, which may be updated by Tornado at any time and for any reason, without notice.
      </Body4>
      <Body4>
        11.2 Enrollment in the Subscription Service entitles you to limited commission-free trading on the Tornado
        Services until the termination of your enrollment. The price for the Subscription Service (the
        &ldquo;Subscription Fee&ldquo;), number of commission-free trades you receive per month, and number of remaining
        trades, will be indicated to you on the Tornado website. Any trades in excess of the allotted number of monthly
        commission-free trades will incur Tornado&apos;s prevailing commission fee, currently $4.50 per trade. You agree
        that you must pay any regulatory fees, margin interest, taxes, service fees, and any and all other
        non-commission fees and charges related to your Tornado account. Subscription fee payments are for trading
        services only and do not constitute a payment for investment advice, account management, recommendations, tax
        advice, or legal advice, none of which is offered by Tornado.
      </Body4>
      <Body4>
        11.3 You will pay the Subscription Fee, as indicated to you when you sign up and in the Settings section of the
        Tornado website. You may be offered a promotional price for the first month of Subscription Service, after which
        the indicated Subscription Fee will come into effect. You agree to make monthly recurring payments via your
        credit or debit card of choice, your linked bank account, or directly from your Tornado account, as applicable,
        and authorize and direct Tornado to charge your card, linked bank account, or Tornado account for such payments.
        In the event that there is not a sufficient cash balance in your Tornado account to pay the Subscription Fee,
        the partial or full Subscription Fee may be charged to your linked bank account and Tornado may, in its sole
        discretion, liquidate positions in your Tornado account to generate sufficient cash to pay the Subscription Fee.
        If the full subscription amount cannot be collected for any reason, Tornado may, as a courtesy and in its sole
        discretion, collect a partial subscription payment and provide you another month of Subscription Service.
      </Body4>
      <Body4>
        11.4 Subscription Fee will be charged on or around the same day every month as your subscription began, or on
        the last day of the month, except that your initial payment may be charged up to one week after your
        subscription began. (For example, if your subscription began on June 15th, your first payment may be around June
        22nd, and you will continue to be charged on or around the 15th of subsequent months; if your subscription began
        on May 31st, your first payment may be around June 7th, and you will be charged on or around the last day of
        every subsequent month.) Past-due payments may be charged as soon as a sufficient balance is available.
      </Body4>
      <Body4>
        11.5 For subscriptions initiated prior to 12/12/2019: You may cancel your subscription at any time. If you
        subscribe and then cancel your subscription, you will pay Tornado&apos;s prevailing commission fee, currently
        $4.50 per trade, upon the expiration of your subscription at the end of your current subscription month. If you
        decide to re-subscribe in the future after canceling a subscription, you will be required to pay in advance for
        3 months of Subscription Service at the then-prevailing monthly price. If you subscribe and then change your
        mind, cancel within the first 7 days of payment to receive a full refund, provided that you have not placed any
        trades since enrolling in Subscription Service. If you cancel your subscription after you have placed trades or
        more than 7 days have elapsed since your initial payment, you may continue to enjoy unlimited commission-free
        trading until the end of the currently paid month of service, at which time subscription will terminate. If your
        initial or any subsequent payment fails, your subscription will be canceled and you will be subject to a 3-month
        prepayment if you choose to subscribe again.
      </Body4>
      <H6>
        <Bold>12. INTERNATIONAL USE</Bold>
      </H6>
      <Body4>
        Because of the global nature of the Internet, you agree to comply with all local rules with respect to your
        account and your online conduct, including all laws, rules, codes, and regulations of the country in which you
        reside and the country from which you access this site, including without limitation, all laws, rules, codes,
        regulations, decrees, acts, orders, directives, legislation, bills, and statutes pertaining to tax, contracts,
        intellectual property, securities, e-commerce, banking, technology, computers, fraud, and privacy. In addition,
        you agree to comply with all applicable laws, rules, codes, and regulations regarding the transmission of
        technical data exported from the United States.
        <Bold>
          This site will not be considered a solicitation for or offering or recommendation of any investment product or
          service to any person in any jurisdiction where such solicitation, offering or recommendation would be
          illegal.
        </Bold>
      </Body4>
      <H6>
        <Bold>13. DISCLAIMERS AND LIMITATIONS OF LIABILITY</Bold>
      </H6>
      <Body4>
        13.1 YOU AGREE THAT YOUR USE OF ANY CONTENT OR SERVICE IS AT YOUR SOLE RISK AND ACKNOWLEDGE THAT ALL CONTENT AND
        SERVICES ARE PROVIDED &ldquo;AS IS&ldquo; AND &ldquo;AS AVAILABLE.&ldquo;&nbsp; THE CONTENT MAY INCLUDE
        INACCURACIES OR TYPOGRAPHICAL ERRORS.&nbsp; CHANGES ARE PERIODICALLY MADE TO THE CONTENT.&nbsp; SAVE AS PROVIDED
        IN THESE TERMS, NEITHER WE NOR OUR SUPPLIERS AND LICENSORS MAKE ANY REPRESENTATIONS OR WARRANTIES AND, TO THE
        FULLEST EXTENT ALLOWED BY LAW, EXCLUDE ALL IMPLIED WARRANTIES (INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF
        MERCHANTABILITY, TITLE AND FITNESS FOR A PARTICULAR PURPOSE) REGARDING (A) THE SUITABILITY OF THE INFORMATION;
        (B) THE ACCURACY, AVAILABILITY, RELIABILITY, COMPLETENESS OR TIMELINESS OF THE SITES, CONTENT OR SERVICES,
        INCLUDING WITHOUT LIMITATION PRICE QUOTES WHICH MAY BE DELAYED, AND INVESTMENT RESEARCH AND IDEAS WHICH MAY NOT
        BE UPDATED TO REFLECT CURRENTLY AVAILABLE INFORMATION;&nbsp; OR (C) THE RESULTS OBTAINED FROM ACCESSING AND
        USING ANY SITE, SERVICE OR CONTENT.&nbsp; FURTHER, WE DO NOT REPRESENT OR WARRANT THAT (W) THE FUNCTIONS
        CONTAINED IN THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE; (X) DEFECTS WILL BE CORRECTED; (Y) THE SERVICES
        OR THE SERVERS THAT MAKE THEM AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS; NOR (Z) THE USE OF ANY
        OF THE CONTENT WILL NOT INFRINGE THE INTELLECTUAL PROPERTY RIGHTS OF ANY THIRD PARTY. You understand that we
        cannot and do not guarantee or warrant that files available for downloading from the Internet or the Services
        will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures
        and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and
        output, and for maintaining a means external to our site for any reconstruction of any lost data.
      </Body4>
      <Body4>
        13.2 The Content is made available for your general information and use and is not intended to address your
        particular requirements. We do not represent or endorse the accuracy, completeness or reliability of any advice,
        opinion, statement or other information forming part of the Content; however, we use such efforts as we deem
        reasonable to maintain the accuracy and correctness of the Content that is provided by Tornado, but you should
        rely only on your professional advisers and independent research. Reliance upon any Content shall be at your own
        risk. The Content does not constitute any form of advice, recommendation or arrangement by us (including,
        without limitation, legal, accounting, tax or investment advice) and is not intended to be relied upon by users
        in making (or refraining from making) any decisions. A portfolio allocated in accordance with mathematical
        formulas presented on the site could have returns lower, higher, or equal to a portfolio that is not allocated
        in this way. Appropriate independent advice should be obtained before making any investment decision. Any
        arrangements made between you and any third party are at your sole risk and responsibility.
      </Body4>
      <Body4>
        The Services and the Content may contain information that includes or is based upon forward-looking statements
        within the meaning of federal securities laws. Forward-looking statements are made based on current expectations
        and beliefs concerning future developments and their potential effects. You can identify these statements by the
        fact that they do not relate solely to historical or current facts. They generally include words such as
        “believe”, “expect”, “anticipate”, “intend” and similar words. There can be no assurance that future
        developments will be in accordance with expectations or that the effect of future developments will be correctly
        anticipated. The following important factors, risks, and uncertainties are among those that may affect such
        statements: (a) changes in performance of financial markets and interest rates; (b) development of new financial
        products; and (c) regulatory, accounting or tax changes that may affect the cost of, or demand for, our
        financial products or services.
      </Body4>
      <Body4>
        13.3 IN NO EVENT WILL TORNADO, ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS
        OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH
        YOUR USE, OR INABILITY TO USE, THE SERVICES, ANY CONTENT, ANY WEBSITES LINKED TO THE SERVICES, INCLUDING ANY
        DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL
        INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR
        ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING
        NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE OR NOTIFIED TO US, INCLUDING WITHOUT
        LIMITATION DAMAGES ARISING, IN WHOLE OR IN PART, DIRECTLY OR INDIRECTLY, FROM ANY EVENT BEYOND THE CONTROL OF
        TORNADO, ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS
        (INCLUDING, BUT NOT LIMITED TO, NATURAL DISASTER, WAR, INVASION, ACT OF FOREIGN ENEMIES, RIOT, STRIKE, ACT OR
        THREAT OF TERRORISM, FAILURE OF UTILITIES OR COMPUTER SYSTEMS). THE FOREGOING DOES NOT AFFECT ANY LIABILITY
        WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
      </Body4>
      <Body4>
        13.4 Neither we nor any representative shall be liable to you for any direct or indirect damage, loss or
        expenses suffered by you as a result of:
      </Body4>
      <Body4>
        (a) any viruses, worms, “Trojan horses” or similar programs, denial of service attack, spamming or hacking or
        consequential damages or any claim against us by any other party;
      </Body4>
      <Body4>
        (b) any fault, inaccuracy, omission, delay or any other failure in any Service or Content caused by your
        computer equipment or arising from your use of any Service or Content on such equipment;
      </Body4>
      <Body4>
        (c) any inaccuracies or errors in or omissions from any Content including, but not limited to, quotes and
        financial data;
      </Body4>
      <Body4>
        (d) any delays, interruptions or short-term or immaterial errors in the transmission or delivery of any Service;
        or
      </Body4>
      <Body4>(e) any additions, deletions or changes made to the Content at any time.</Body4>
      <Body4>
        13.5 Notwithstanding anything contained elsewhere in these Terms, in the event that you incur any loss, damage
        or expense arising out of your use of any Content or Service, you agree that our liability to you shall be
        limited to the higher of (a) the total amounts paid by you to us in the last month in relation to Content or
        Service, and (b) the sum of $1,000.
      </Body4>
      <H6>
        <Bold>14. INDEMNITY</Bold>
      </H6>
      <Body4>
        You agree to indemnify and hold us, our representatives, licensors and sub-contractors harmless from and against
        any and all costs, claims, damages, proceedings, causes of action, liability and expenses (including without
        limitation attorney’s fees and costs) that we might incur by reason of a breach by you of these Terms or arising
        out of your use or sharing of the Services, including, but not limited to, any Posted Material, any use or
        sharing of the Content or Services other than as expressly authorized in these Terms, or your use or sharing of
        any information obtained from the Services. For the avoidance of doubt, this indemnity shall extend (without
        limitation) to any losses that we may suffer as a result of the use by third parties of your user name and
        password.
      </Body4>
      <H6>
        <Bold>15. CHANGES TO THESE TERMS</Bold>
      </H6>
      <Body4>
        We may make additions, deletions or changes (together, <Bold>&ldquo;amendments&ldquo;</Bold> ) to the provisions
        of these Terms from time to time.&nbsp; Any amended Terms will be notified to you by being posted through the
        Services. It is your responsibility to refer regularly to these Terms and note any amendments. Amendments will
        come into effect immediately on the amended Terms being posted through the Services and you will be deemed to
        have accepted them if you access the Services after that time.&nbsp; If you do not wish to accept them, you must
        cancel the Services.
      </Body4>
      <H6>
        <Bold>16. TERM AND CANCELLATION</Bold>
      </H6>
      <Body4>
        16.1 The rights granted to you herein terminate immediately upon any violation by you of these Terms of Service.
        Tornado, in its sole discretion, reserves the right to temporarily or permanently terminate your access to and
        use of this site at any time and for any reason whatsoever, without notice or liability. Tornado will not be
        liable to you or any third party for any termination of your access to or use of this site
      </Body4>
      <Body4>
        16.2 Termination of your access to and use of any Services and Content, regardless of the reason, shall not
        affect Tornado&apos;s right to receive any outstanding sums due at the date of termination, which sums shall be
        payable within fifteen (15) days of such termination.
      </Body4>
      <Body4>
        16.3 Termination of your access to and use of any Services and Content, regardless of the reason, shall not
        relieve you of your confidentiality obligations hereunder, which shall remain in effect into perpetuity.
      </Body4>
      <Body4>
        16.4 Upon termination of this agreement or of your access to and use of any Services and Content, you agree to
        immediately destroy copies of all Content, in electronic form or otherwise, then in your possession.
      </Body4>
      <Body4>
        16.5 Brokerage accounts that have been inactive for 12 months or more and that have a net equity value of $10 or
        less may be closed by Tornado. Positions may be liquidated and a termination fee of up to $10 may be assessed,
        in Tornado&apos;s sole discretion.
      </Body4>

      <H6>
        <Bold>17. NO WAIVER</Bold>
      </H6>
      <Body4>
        Failure by either party to exercise any right or remedy under these Terms does not constitute a waiver of that
        right or remedy.
      </Body4>
      <H6>
        <Bold>18. ENTIRE AGREEMENT</Bold>
      </H6>
      <Body4>
        These Terms (including the Privacy Policy and any other terms incorporated by reference in these Terms) shall
        constitute the entire agreement between you and us with respect to your access to and use of any Services and
        supersede all prior agreements, negotiations and discussions between you and us relating to the same.
      </Body4>
      <H6>
        <Bold>19. GOVERNING LAW AND JURISDICTION</Bold>
      </H6>
      <Body4>
        All matters relating to the Services and these Terms and any dispute or claim arising therefrom or related
        thereto (in each case, including non-contractual disputes or claims), shall be governed by and construed in
        accordance with the internal laws of the State of New York without giving effect to any choice or conflict of
        laws provision or rule (whether of the State of New York or any other jurisdiction). Any legal suit, action or
        proceeding arising out of, or related to, these Terms or the Services shall be instituted exclusively in the
        federal courts of the United States or the courts of the State of New York, in each case located in the City of
        New York and County of New York, although we retain the right to bring any suit, action or proceeding against
        you for breach of these Terms in such other venue as we deem appropriate. You waive any and all objections to
        the exercise of jurisdiction over you by such courts and to venue in such courts.
      </Body4>
      <H6>
        <Bold>20. ASSIGNMENT AND SUB-CONTRACTING</Bold>
      </H6>
      <Body4>
        You may not assign, sublicense or otherwise transfer any of your rights under these Terms without our prior
        written consent and any purported assignment in violation hereof shall be void.
      </Body4>
      <H6>
        <Bold>21. SEVERABILITY</Bold>
      </H6>
      <Body4>
        If any provision of these Terms is found to be wholly or partially invalid, void or unenforceable by any court
        having competent jurisdiction or by virtue of any legislation or any other reason, that provision shall be
        invalid, void or unenforceable to that extent only and no further and the validity and enforceability of the
        remaining provisions of these Terms shall not be affected.
      </Body4>
      <H6>
        <Bold>22. NOTICES</Bold>
      </H6>
      <Body4>
        Any notice that is required to be given pursuant to these Terms shall be made by email or posted on the site
        and, in the case of us, to the address posted through the Services or otherwise notified to you in relation to
        any relevant Service.&nbsp; Any such notice shall be deemed to have arrived if sent by post within three (3)
        days of posting and if sent by email at the time of transmission.
      </Body4>
      <H6>
        <Bold>23. HEADINGS</Bold>
      </H6>
      <Body4>Headings in these Terms are for convenience only and will have no legal meaning or effect.</Body4>
    </div>
  );
};
